import React from 'react';
import Content from './Content'
import ChangeVideo from './ChangeVideo'
import { connect } from 'react-redux'
import _ from 'lodash';
import YouTube from 'react-youtube';
import VideoEditor from './VideoEditor'


const App = ({ videos, match, history, scrollForm, scrollHeader, scrollWebsite }) => !match.params.videoId ? ( <div className="AppVideo">
        <Content scrollWebsite={scrollWebsite} />
        <ChangeVideo scrollHeader={scrollHeader} />
    </div> ) : ( <div className="AppVideo">
        {/* <iframe className="videoWrapper" src={_.find(videos, { id: match.params.videoId }).iframeurl} />*/}
        <YouTube
            className="videoWrapper"
            videoId={_.find(videos, { Id: match.params.videoId }).VideoId}
            onPause={ () => { history.push("/videos"); scrollForm(); }}
            onEnd={ () => { history.push("/videos"); scrollForm(); } }
            opts={{
                playerVars: { // https://developers.google.com/youtube/player_parameters
                    autoplay: 1,
                    controls: 0,
                    end: _.find(videos, { Id: match.params.videoId }).VideoEndSeconds
                }
            }}
        />

        <VideoEditor videoId={ match.params.videoId } />
        <ChangeVideo scrollHeader={scrollHeader} />
    </div> )

export { App };
export default connect(
    (state) => state.app
)(App);



// WEBPACK FOOTER //
// ./src/components/VideoMode/App.js